exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-date-picker-table.v-date-picker-table--date>table{background-color:#fff}#logs-table table tr{cursor:pointer}.v-list-item{-webkit-user-select:inherit;-moz-user-select:inherit;user-select:inherit}", ""]);

// exports
